// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"a0c0e3e31e34de0e","9601":"bf3b217b7955ee0e"}[chunkId] + ".css";
};